import './App.css';
// import Home from './pages/home/Home';
import 'owl.carousel/dist/assets/owl.carousel.css';
import Landing from './pages/landing/Landing';
import { BrowserRouter, HashRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/home/Home';
import Services from './pages/services/Services'
import Career from './pages/career/Career';
import AOS from "aos";
import "aos/dist/aos.css";

import { useEffect } from 'react';
import WhyChoose from './pages/whychoose/WhyChoose';
import About from './pages/about/About';
import Contact from './pages/contact/Contact';
import Mission from './pages/mission/Mission';
import Privacy from './pages/privacy/Privacy';
import Policy from './pages/policy/Policy';
import Terms from './pages/terms/Terms';
import Blog from './pages/blog/Blog';
import Blogdetails from './pages/blog/Blogdetails';
import Delivery from './pages/blog/Delivery';
import Shipping from './pages/shipping/Shipping';
import Cancecllation from './pages/cancellation/Cancellation';
import { HelmetProvider } from 'react-helmet-async';


function App() {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease',
      once: true,
    })
  }, [])
  return (
    <HelmetProvider>
      <HashRouter>
        <Routes>
          <Route path='/earlyaccess' element={<Landing />} />
          <Route path='/' element={<Home />} />
          <Route path='/service' element={<Services />} />
          <Route path='/career' element={<Career />} />
          <Route path='/whychoose' element={<WhyChoose />} />
          <Route path='/about' element={<About />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/mission' element={<Mission />} />
          <Route path='/privacy' element={<Privacy />} />
          <Route path='/policy' element={<Policy />} />
          <Route path='/terms-conditions' element={<Terms />} />
          <Route path='/blog' element={<Blog />} />
          <Route path='/blog-details' element={<Blogdetails />} />
          <Route path='/delivery' element={<Delivery />} />
          <Route path='/shipping-and-delivery' element={<Shipping />} />
          <Route path='/cancellation-and-refund' element={<Cancecllation />} />
        </Routes>
      </HashRouter>
    </HelmetProvider>
  );
}

export default App;
